import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { IMetaPage } from '@feathr/blackbox';
import { ConnectionCard } from '@feathr/components';

interface IMetaFacebookPagesCardProps {
  pages: IMetaPage[];
}

function getPageUrl(pageId: string): string {
  return `https://facebook.com/${pageId}`;
}

function MetaFacebookPagesCard({ pages }: Readonly<IMetaFacebookPagesCardProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <ConnectionCard name={'meta-facebook-pages-card'}>
      <ConnectionCard.Header count={pages.length} icon={faFacebook} iconTheme={'blue'}>
        {t('Facebook Pages')}
      </ConnectionCard.Header>
      <ConnectionCard.Items>
        {pages.map((page) => (
          <ConnectionCard.Item href={getPageUrl(page.id)} key={page.id}>
            {page.name}
          </ConnectionCard.Item>
        ))}
      </ConnectionCard.Items>
    </ConnectionCard>
  );
}

export default MetaFacebookPagesCard;
